import type React from 'react';
import styled from 'styled-components';
import classNames from 'classnames';
import { useStore } from 'effector-react';
import { ImageType, LogoType, TemplateId } from '@types';
import { LOGO_URL } from '@constants';
import { $templateId, $tourData } from '@stores/dataStores';
import { $editingLogo } from '@stores/editingStores';
import Image from '@components/Image';
import useEditingStore from '@hooks/useEditingStore';
import { getTemplateConfig } from '@utils/templateConfig';
import cn from '@utils/cn';

interface Props {
  className?: string;
  systemIcon?: React.ReactNode;
}

const Placeholder = styled.div`
  width: 100px;
  height: 100px;
  background: rgba(40, 110, 250, 0.3);
  border: 1px solid #286efa;
`;

function WLogo({ className, systemIcon }: Props) {
  const templateId = useStore($templateId);
  const hasFeature = getTemplateConfig(templateId)('logo');
  const logo = useEditingStore({
    $data: $tourData,
    dataFn: (state) => state.logo,
    $editing: $editingLogo.store,
  });
  const type = hasFeature ? logo?.type ?? LogoType.system : LogoType.system;
  const scale = logo?.scale ?? 1;
  if (type === LogoType.system) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    if (systemIcon) return <>{systemIcon}</>;
    return (
      <Image
        style={{ width: 60, height: 32 }}
        className={className}
        src={LOGO_URL}
        type={ImageType.sysMedia}
      />
    );
  }
  if (type === LogoType.custom) {
    return logo?.iconMediaUrl ? (
      <Image
        className={cn('max-h-[100px] max-w-[100px]', className)}
        style={{
          transform: `scale(${scale})`,
          transformOrigin: `top ${
            templateId === TemplateId.simple ? 'right' : 'left'
          }`,
        }}
        src={logo.iconMediaUrl}
        type={ImageType.media}
      />
    ) : (
      <Placeholder
        className={classNames(
          'flex items-center justify-center text-sm',
          className
        )}
      >
        还未添加LOGO
      </Placeholder>
    );
  }
  return null;
}

export default WLogo;
